import { render, staticRenderFns } from "./sq-logo.vue?vue&type=template&id=6ac60149&scoped=true"
import script from "./sq-logo.vue?vue&type=script&lang=js"
export * from "./sq-logo.vue?vue&type=script&lang=js"
import style0 from "./sq-logo.vue?vue&type=style&index=0&id=6ac60149&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac60149",
  null
  
)

export default component.exports